import React from 'react';
import { noop } from 'lodash';
import styles from './RemoveIconButton.module.scss';

interface Props {
	onClick?: () => void;
}

const RemoveIconButton = ({ onClick = noop }: Props) => {
	return (
		<div className={styles.removeBtn} onClick={onClick}>
			<img
				className={styles.removeIcon}
				src='/dist/icons/close.svg'
				alt='remove'
			/>
		</div>
	);
};

export default RemoveIconButton;
